"use strict";
var datetime_1 = require('./datetime');
exports.NguiDatetime = datetime_1.NguiDatetime;
var datetime_picker_component_1 = require('./datetime-picker.component');
exports.NguiDatetimePickerComponent = datetime_picker_component_1.NguiDatetimePickerComponent;
var datetime_picker_directive_1 = require('./datetime-picker.directive');
exports.NguiDatetimePickerDirective = datetime_picker_directive_1.NguiDatetimePickerDirective;
var datetime_picker_module_1 = require('./datetime-picker.module');
exports.NguiDatetimePickerModule = datetime_picker_module_1.NguiDatetimePickerModule;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@ngui/datetime-picker/dist/index.js
// module id = 535
// module chunks = 4